import { render, staticRenderFns } from "./VmPlans.vue?vue&type=template&id=bf886edc"
import script from "./VmPlans.vue?vue&type=script&lang=js"
export * from "./VmPlans.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports